export default __webpack_public_path__ + "media/images/theme_apple/backButton-a842523c44f1bc61598ad15f33bf473e.png";